import styled from 'styled-components';

import { breakpoints, colors, spacing } from '../../constants';

interface IProps {
    backgroundGrey?: boolean;
}

export const NavigationButtonIconWrapper = styled.div<IProps>`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${(props) =>
        props.backgroundGrey ? colors.grey : colors.white};
    cursor: pointer;
    z-index: 1;
    margin: 0 ${spacing.sm};

    @media (${breakpoints.mediumMin}) {
        width: 40px;
        height: 40px;
    }
`;
